import { z } from "zod";

const signUpIndividualSchema = z.object({
  name: z.string().min(5, "Name is required"),
  email: z.string().email("Invalid email"),
  phone: z
    .string()
    .min(8, "phone must be at least 8 characters")
    .regex(/^(\+|\d)(\d+)$/, "Invalid phone number"),
  password: z.string().min(9, "Password must be at least 9 characters"),
  confirmPassword: z.string(),
  type: z.literal("ID"),
});
const requiredNumberUnion = (fieldName) =>
  z.preprocess(
    (val) => {
      if (val === "") return undefined;
      if (typeof val === "string" || typeof val === "number")
        return Number(val);
      return val;
    },
    z
      .number({ required_error: `${fieldName} est requis.` })
      .refine((val) => !isNaN(val), {
        message: `${fieldName} doit être un nombre valide.`,
      })
  );

const signUpCompanyCLTSchema = z.object({
  type: z.literal("CLT"),
  name: z.string().min(5, "Name is required"),
  company: z.string().min(2, "Company is required"),
  planId: requiredNumberUnion("Le plan"),
  country: requiredNumberUnion("Le pays"),
  state: requiredNumberUnion("L'état"),
  email: z.string().email("Invalid email"),
  phone: z.string().min(8, "phone must be at least 8 characters"),
  password: z.string().min(5, "Password must be at least 5 characters"),
  confirmPassword: z.string(),
  clientType: z.string(),
  address: z.string(),
  city: z.string(),
  domain: requiredNumberUnion("Le domaine"),
  task: requiredNumberUnion("La tâche"),
  comment: z.string().optional(),
});


const signUpCompanyPASchema = z.object({
  name: z.string().min(5, "Name is required"),
  company: z.string().min(2, "Company is required"),
  planId: requiredNumberUnion("Le plan"),
  country: requiredNumberUnion("Le pays"),
  state: requiredNumberUnion("L'état"),
  email: z.string().email("Invalid email"),
  phone: z.string().min(8, "phone must be at least 8 characters"),
  password: z.string().min(5, "Password must be at least 5 characters"),
  confirmPassword: z.string(),
  clientType: z.string(),
  address: z.string(),
  city: z.string(),
  type: z.literal("PA"),
  domain: requiredNumberUnion("Le domaine"),
  task: requiredNumberUnion("La tâche"),
  comment: z.string().optional(),
});

const useSignupValidationHook = (type = "ID") => {
  switch (type) {
    case "CLT":
      return signUpCompanyCLTSchema;
    case "PA":
      return signUpCompanyPASchema;
    case "ID":
    default:
      return signUpIndividualSchema;
  }
};

export default useSignupValidationHook;
